import { render } from "./TrainingView.vue?vue&type=template&id=0f6ff755&scoped=true"
import script from "./TrainingView.vue?vue&type=script&lang=js"
export * from "./TrainingView.vue?vue&type=script&lang=js"

import "./TrainingView.vue?vue&type=style&index=0&id=0f6ff755&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/Users/georgeconstantine/Documents/import/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6ff755"]])

export default __exports__